import { render, staticRenderFns } from "./appointment-success-card.vue?vue&type=template&id=13d85f8a&scoped=true&"
import script from "./appointment-success-card.vue?vue&type=script&lang=js&"
export * from "./appointment-success-card.vue?vue&type=script&lang=js&"
import style0 from "./appointment-success-card.vue?vue&type=style&index=0&id=13d85f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d85f8a",
  null
  
)

export default component.exports